// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="paywalls.PayersCountByCampaignMissionChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="paywalls.PayersPercentageByCampaignMissionChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="paywalls.PaymentCountByCampaignMissionChart"></bfg-chart>
    </div>
</div>

<hr/>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <div class="title h4" ng-show="aggr">
            Игроки, выполнившие миссии {{ aggr.min_mission }} - {{ aggr.max_mission }},
            совершили {{ aggr.payment_count }} платежей на этих миссиях
        </div>
        <div class="pull-right">
            <a href="{{ aggr.caption_url }}">{{ aggr.caption_text }}</a>
        </div>
    </div>
</div>

<hr/>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="paywalls.PaymentSumByCampaignMissionChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="paywalls.ARPUByCampaignMissionChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;